// 商城
import {Request} from "@";

export const getVirtualProjectList = async params => {
  const gql = `query virtualProjectList($query: FormQuery, $bidList: [String!], $queryProjectUser: FormQuery, $key: String, $isMeCollect: Boolean, $isMeHandle: Boolean, $incExtHandle: Boolean = false) {
  me {
    virtualProjectList(
      query: $query
      bidList: $bidList
      key: $key
      isMeHandle: $isMeHandle
      isMeCollect: $isMeCollect
    ) {
      data {
        ...project
        masterArray {
          ...organizeBranchUser
        }
        leaderArray {
          ...organizeBranchUser
        }
        taskAuto {
          tid
        }
        projectUserList(query: $queryProjectUser) {
          data {
            ...projectUser
          }
          meta {
            ...meta
          }
        }
        extHandle: projectUserList(query: {limit: 1, keyJson: "{ isHandle:true }"}) @include(if: $incExtHandle) {
          meta {
            ...meta
          }
        }
      }
      meta {
        ...meta
      }
    }
  }
}

fragment meta on Meta {
  limit
  page
  count
  num
}

fragment project on Project {
  pid
  uid
  oid
  createTime
  updateTime
  applyTime
  expireTime
  finishTime
  status
  statusTime
  statusCtrl
  level
  isDraft
  priority
  isDelete
  isHandle
  isViewHandle
  isComment
  name
  parent
  comment
  icon
  desc
  restDays
  restDayFrom
  restDayTo
  isLeader
  isExtend
  isArchive
  isMaster
  allowEdit
  allowDel
  allowCategory
  allowNewTask
  allowCollect
  allowComment
  allowConfirm
  allowNote
  allowHandle
  allowTrans
  fileList {
    uid
    note
    type
    hash
  }
  numSon
  numSonDone
  numTask
  numTaskDone
  expireDays
  userInfo {
    ...userBase
  }
  userMapCollectInfo {
    acc
    tid
    cate
    createTime
  }
}

fragment userBase on UserBase {
  uid
  username
  nickname
  profile {
    phone
    name
    realName
    wxIcon
    wxNickname
  }
}

fragment organizeBranch on OrganizeBranch {
  bid
  oid
  name
  createTime
  priority
  numMember
  icon
  desc
  progressTime
  alias
  branchUserArrayByPosition(position: "局长") {
    alias
  }
}

fragment projectUser on ProjectUser {
  pid
  uid
  createTime
  isMaster
  userInfo {
    ...userBase
  }
  organizeBranch {
    ...organizeBranch
  }
  branchUser {
    ...organizeBranchUser
  }
}

fragment organizeBranchUser on OrganizeBranchUser {
  uid
  oid
  bid
  createTime
  status
  priority
  isOwner
  comment
  alias
  roles
  isMaster
  isHide
  level
  position
  position2
  roles
  progressTime
  compareWithMe
  organizeBranch {
    ...organizeBranch
  }
}`;
  return (await Request.request(gql, params, 'qzpm', '工作列表')).me.virtualProjectList;
};
